import React from 'react';

import {
  Flex,
  Text,
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import { FULL_DATETIME_FORMAT } from 'utils/dates';

import AddressInfo from './AddressInfo';
import DriverInfo from './DriversInfo';

interface TranshipmentInfoProps {
  data: any
  isExecution?: boolean
}

export default function TranshipmentInfo({
  data = { },
  isExecution = false,
}: TranshipmentInfoProps) {
  return (
    <Flex flexDir="column">
      <Flex>
        <Flex
          width="60%"
          flexDir="column">
          <Text
            variant="smallBold"
            color="gray.600"
            mb={3}>
            FROTA DE ORIGEM:
          </Text>
          <DriverInfo
            initialKm={data.initialKm}
            finalKm={data.finalKm}
            drivers={data.drivers}
            vehicle={data.vehicle}
          />
          <AddressInfo
            address={data.address}
            my={6}
          />
        </Flex>

        <Flex flexDir="column">
          <Text
            variant="smallBold"
            color="gray.600"
            mb={3}>
            FROTA DE DESTINO:
          </Text>
          <DriverInfo
            initialKm={data.followupInitialKm}
            finalKm={data.followupFinalKm}
            drivers={data.transhipmentDrivers}
            vehicle={data.transhipmentVehicle}
          />
        </Flex>
      </Flex>
      <Flex justifyContent="space-between">
        <Flex flexDir="column">
          <Text
            variant="xSmallSemiBold"
            color="gray.500">
            Previsão:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {dayjs(data.dueDate).format(FULL_DATETIME_FORMAT)}
          </Text>
        </Flex>
        <Flex
          hidden={!isExecution}
          flexDir="column">
          <Text
            variant="xSmallSemiBold"
            color="gray.500">
            Efetuado em:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {data.finishedAt ? dayjs(data.finishedAt).format(FULL_DATETIME_FORMAT) : 'N/A'}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
